import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox',
  imports: [MatCheckbox, MatIcon, TooltipDirective, TranslatePipe, ReactiveFormsModule],
  templateUrl: './checkbox.html',
  styleUrl: './checkbox.scss',
})
export class Checkbox {
  protected readonly TooltipPosition = TooltipPosition;

  className = input.required<string>();
  checkboxControl = input.required<FormControl>();
  label = input<string>();
  infoTooltip = input<string | null>('');
  tooltipWidth = input<number>(350);
}
